import { Component, signal, computed } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PrefixMockService } from '../../../core/services/prefix.service';
import { Prefix } from 'src/app/core/models/DigitalKit';
import { EmailService } from 'src/app/core/services/emailjs.service';
import { take } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { ContactFormData } from 'src/app/core/models/DigitalKit';

@Component({
  selector: 'app-contact-form',
  standalone: true,
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css'],
  imports: [ReactiveFormsModule, FormsModule, CommonModule]
})
export class ContactFormComponent {

  loading = signal(false);
  success = signal(false);
  error = signal(false);

  prefixes = signal<Prefix[]>([]);
  motivesSelected = signal<string[]>([]);
  motivesTouched = signal(false);

  sectors = ["Empresa", "PYME", "Profesional independiente", "Autónomo", "Otro"];
  motives = [
    "Consutoría Marketing",
    "Consultoría IA",
    "UX & UI Design",
    "Marketing Digital",
    "Mantenimiento",
    "Otro"
  ];


  form = this.fb.nonNullable.group({
    name: ['', Validators.required],
    sector: ['', Validators.required],
    otherSector: [''],
    email: ['', [Validators.required, Validators.email]],
    prefix: ['+34', Validators.required],
    phone: ['', [Validators.required, Validators.pattern(/^[0-9+\s-]{9,15}$/)]],
    otherMotive: [''],
    warning: [false, Validators.requiredTrue]
  });


  formValue = toSignal(this.form.valueChanges, { initialValue: this.form.getRawValue() });


  formReady = computed(() => {
    const f = this.formValue();

    if (this.form.invalid) return false;
    if (this.motivesSelected().length === 0) return false;


    if (f.sector === "Otro" && !f.otherSector) return false;


    if (this.motivesSelected().includes("Otro") && !f.otherMotive) return false;

    return true;
  });

  constructor(
    private fb: FormBuilder,
    private prefixService: PrefixMockService,
    private emailService: EmailService
  ) {

    this.prefixService
      .getPrefixes()
      .pipe(take(1))
      .subscribe(data => this.prefixes.set(data));
  }


  toggleMotive(event: Event, motive: string) {
    this.motivesTouched.set(true);
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      this.motivesSelected.set([...this.motivesSelected(), motive]);
    } else {
      this.motivesSelected.set(this.motivesSelected().filter(m => m !== motive));


      if (motive === "Otro") {
        this.form.controls.otherMotive.setValue('');
      }
    }
  }


onSubmit() {
  if (!this.formReady()) return;

  this.loading.set(true);
  this.error.set(false);
  this.success.set(false);

  const f = this.form.getRawValue();

  const data: ContactFormData = {
    name: f.name,
    email: f.email,
    phone: `${f.prefix} ${f.phone}`,
    sector: f.sector === "Otro" ? f.otherSector : f.sector,
    motives: this.motivesSelected().join(', '),
    otherMotive: f.otherMotive || ''
  };

  this.emailService.sendContactForm(data)
    .then(() => {

      this.success.set(true);

      this.form.reset({
        prefix: '+34',
        warning: false
      });

      this.motivesSelected.set([]);
      this.motivesTouched.set(false);

      document
        .querySelectorAll<HTMLInputElement>('input[type="checkbox"]')
        .forEach(cb => cb.checked = false);

      setTimeout(() => {
        this.success.set(false);
      }, 5000);
    })
    .catch((err) => {
      console.error(err);

      this.error.set(true);

      setTimeout(() => {
        this.error.set(false);
      }, 5000);
    })
    .finally(() => {
      this.loading.set(false);
    });
}
}
